import { semanticNavigationGroups as rawSemanticNavigationGroups } from './data.js';
import type { SemanticNavGroup } from './types.js';

export const semanticNavigationGroups = rawSemanticNavigationGroups as SemanticNavGroup[];
